import ApiRequestManagerInstance from '../ApiRequestManager';
import FastEvent from '../../classes/fastEvent';
import Rail from '../../classes/rail';
import { IWatchEverythingRequest } from '../../types/interfaces/rail';
import { RailDisplayMode } from '../../types/enums/rail';

function watchEverythingRequest(channelName: string) {
  const promise = new Promise<Rail[]>(async (resolve, reject) => {
    try {
      const response: IWatchEverythingRequest =
        (await ApiRequestManagerInstance.get({
          endpoint: {
            url: 'cdnSyncUrl',
            section: 'fast',
            type: 'fast',
            replacement: channelName,
          },
        })) as unknown as IWatchEverythingRequest;

      const categories: {
        [key: string]: FastEvent[];
      } = {};

      response.data.forEach((item) => {
        if (item.intraCategory) {
          if (!categories[item.intraCategory]) {
            categories[item.intraCategory] = [];
          }
          categories[item.intraCategory].push(new FastEvent(item));
        }
      });

      const rails: Rail[] = [];
      Object.keys(categories).forEach((key) => {
        const baseRail = {
          section: {
            title: key,
            presentationType: RailDisplayMode.PHOTO,
            name: key,
          },
        };
        rails.push(Rail.constructorWithData(baseRail, categories[key]));
      });

      resolve(rails);
    } catch (e) {
      reject([]);
    }
  });

  return promise;
}

export default watchEverythingRequest;
